var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPatientPositioning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: "24px",
    viewBox: "0 -960 960 960",
    width: "24px",
    fill: "#5f6368",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M381.54-440v-200h316.92q49.5 0 84.75 35.25T818.46-520v80H381.54Zm40-160v120-120Zm-280 270.77v-40h676.92v40H141.54ZM226.15-440q-36.15 0-60.38-24.23-24.23-24.23-24.23-60.39 0-36.15 24.23-60.38 24.23-24.23 60.38-24.23 36.16 0 60.39 24.23 24.23 24.23 24.23 60.38 0 36.16-24.23 60.39Q262.31-440 226.15-440Zm0-40q18.97 0 31.79-12.83 12.83-12.82 12.83-31.79 0-18.96-12.83-31.78-12.82-12.83-31.79-12.83-18.96 0-31.78 12.83-12.83 12.82-12.83 31.78 0 18.97 12.83 31.79Q207.19-480 226.15-480Zm195.39 0h356.92v-40q0-33-23.5-56.5t-56.5-23.5H421.54v120Zm-195.39-44.62Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPatientPositioning);
export default __webpack_public_path__ + "static/media/patient_positioning.2c838de0becb5df9e0be3bcb0d28b88f.svg";
export { ForwardRef as ReactComponent };